/* eslint-disable max-lines */
import React, { useContext, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
    getPatientForms,
    editForm,
    getFormStructure,
    createFormInstance,
    getAllFormStructure,
    deleteForm
} from '../../redux/Forms/FormsAction';
import PropTypes from 'prop-types';
import MedicalHistoryForm from './Form/MedicalHistoryForm';
import { CircularProgress, Grid, makeStyles, MenuItem, Select, InputBase } from '@material-ui/core';
import * as Yup from 'yup';
import HistoryFormList from './Form/HistoryFormList';
import MessagesContext from '../../contexts/messagesContext';
import LanguageContext from '../../contexts/languageContext';
import { DropDownIcon } from '../UI/Images/Icons';
import WithPatientFileHeader from '../PatientFileHeader/WithPatientFileHeader';
import { useParams } from 'react-router-dom';

const styles = makeStyles({
    progressContainer: {
        height: '100%',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    labelTitle: {
        display: 'inline-block',
        fontSize: '16px',
        fontWeight: 'bold',
        padding: '0 15px 0 10px'
    },
    mainOption: {
        borderRadius: '6px',
        lineHeight: '1.67em',
        height: '1.67em',
        textAlign: 'center',
        fontSize: '14px'
    },
    icon: (props) => ({
        position: 'absolute',
        left: props.rtl ? '12px' : 'auto',
        right: props.rtl ? 'auto' : '12px',
        pointerEvents: 'none'
    }),
    optionItem: {
        fontWeight: 'bold'
    },
    loaderContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    loader: {
        width: '15px !important',
        height: '15px !important'
    },
    // innerContainer: {
    //     padding: '10px 23px',
    //     background: '#fff',
    //     borderRadius: '8px'
    // },
    formContainer: {
        maxWidth: '950px',
        padding: '0 45px',
        margin: 'auto'
    },
    inputRoot: {
        width: 'calc(100% - 165px)'
    },
    selectContainer: {
        padding: '3px 10px',
        backgroundColor: '#f5f7fa',
        borderRadius: '6px',
        marginBottom: '17px'
    }
});
function PatientHistory(props) {
    const { messages } = useContext(MessagesContext);
    const { lang } = useContext(LanguageContext);
    const classes = styles({ rtl: lang === 'fa' });
    const params = useParams();
    const patientId = params?.id;
    const { getPatientForms, getAllFormStructure } = props;

    const [selectedFormType, setSelectedFormType] = useState(null);
    const [selectedForm, setSelectedForm] = useState(null);
    const [formValues, setFormValues] = useState(null);
    const [newlyAdded, setNewlyAdded] = useState(false);
    useEffect(() => {
        function getForms() {
            if (!selectedForm) {
                if (!props.formStructure) {
                    getAllFormStructure();
                }
            }
        }
        getForms();
    }, [selectedForm, patientId, getPatientForms, getAllFormStructure, props.formStructure]);
    useEffect(() => {
        if (props.forms && props.forms[0] && props.forms[0].id && newlyAdded) {
            changeSubmissionType(props.forms[0].id);
        }
    }, [props.forms]);
    useEffect(() => {
        if (props.formStructure && props.formStructure[0]) {
            // getFormStructure(props.formStructure[0].form_type);
            getPatientForms(patientId, props.formStructure[0].form_type);
            setSelectedFormType(props.formStructure[0]);
            setSelectedForm(props.formStructure[0]);
            convertAPIParamToValues(props.formStructure[0]);
        }
    }, [props.formStructure, patientId, getPatientForms]);
    const createInstance = async (form) => {
        setNewlyAdded(true);
        const param = convertValuesToAPIParam(form);
        await props.createFormInstance(selectedFormType.form_type, patientId, param);
    };
    const editFormInstance = async (form) => {
        setNewlyAdded(false);
        const param = convertValuesToAPIParam(form);
        await props.editForm(selectedForm?.id, param);
    };
    const convertValuesToAPIParam = (form) => {
        let param = {};
        for (let field of selectedForm?.sections[0].fields) {
            if (field.type === 'checkboxes') {
                param[field.name] = form[field.name].join(';');
            } else {
                param[field.name] = form[field.name];
            }
        }
        return param;
    };

    const changeSubmissionType = (formId) => {
        if (!formId) {
            setSelectedForm(selectedFormType);
            convertAPIParamToValues(selectedFormType);
        } else {
            const form = props.forms.find((val) => val.id === formId);
            setSelectedForm(form);
            convertAPIParamToValues(form);
        }
    };
    const handleSubmission = async (form) => {
        if (!selectedForm.id) {
            await createInstance(form);
        } else {
            await editFormInstance(form);
        }
    };

    const convertAPIParamToValues = (form) => {
        if (!form?.sections && !form?.sections[0].fields) {
            return;
        }
        const fields = form.sections[0].fields;
        let fieldObject = {};
        let validation = {};
        for (let field of fields) {
            if (field.type === 'checkboxes') {
                fieldObject[field.name] = field.value ? field.value.split(';') : [];
            } else if (field.type === 'radios') {
                fieldObject[field.name] = field.value ? field.value : '';
            } else {
                fieldObject[field.name] = field.value ? field.value : '';
                validation[field.name] = field.max_length
                    ? Yup.string().max(field.max_length, messages.validations.exceedMaxLength)
                    : Yup.string();
            }
        }
        setFormValues({
            values: fieldObject,
            validation
        });
    };
    const changeFormType = (e) => {
        setNewlyAdded(false);
        const formType = e.target.value;
        const foundForm = props.formStructure.find((form) => form.form_type === formType);
        if (foundForm) {
            getPatientForms(patientId, foundForm.form_type);
            setSelectedFormType(foundForm);
            setSelectedForm(foundForm);
            convertAPIParamToValues(foundForm);
        }
    };
    const handleDeleteForm = (formId) => {
        props.deleteForm(formId);
    };
    return props.formStructure ? (
        <>
            {/* {isMobile && <NavBar title={messages.sidebar.visit} />} */}

            <div>
                <Grid container>
                    <Grid xs={12}>
                        <div className={classes.selectContainer}>
                            <div className={classes.labelTitle}>{messages.selectFormType}:</div>
                            <Select
                                IconComponent={() => <DropDownIcon height="24" width="24" />}
                                classes={{
                                    select: classes.mainOption,
                                    root: classes.selectRoot,
                                    input: classes.inputRoot
                                }}
                                value={selectedFormType ? selectedFormType.form_type : ''}
                                onChange={changeFormType}
                                input={<InputBase className={classes.inputRoot} />}
                            >
                                {props.formStructure &&
                                    props.formStructure.map((formType) => (
                                        <MenuItem
                                            key={formType.form_type}
                                            value={formType.form_type}
                                        >
                                            {formType.title}{' '}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </div>
                    </Grid>
                    <Grid item md={2} xs={12}>
                        <HistoryFormList
                            forms={props.forms}
                            selectedFormId={selectedForm?.id}
                            handleDeleteForm={handleDeleteForm}
                            handleSelectForm={(formId) => changeSubmissionType(formId)}
                        />
                    </Grid>
                    <Grid item md={10} xs={12}>
                        <div className={classes.formContainer}>
                            {selectedForm?.sections && (
                                <MedicalHistoryForm
                                    sections={selectedForm?.sections}
                                    values={formValues?.values}
                                    validation={formValues?.validation}
                                    formId={selectedForm?.id}
                                    submit={handleSubmission}
                                />
                            )}
                        </div>
                    </Grid>
                </Grid>
            </div>
        </>
    ) : (
        <div className="loadingContainer">
            <CircularProgress />
        </div>
    );
}
PatientHistory.propTypes = {
    getPatientForms: PropTypes.func,
    match: PropTypes.object,
    forms: PropTypes.array,
    formStructure: PropTypes.array,
    getFormStructure: PropTypes.func,
    createFormInstance: PropTypes.func,
    editForm: PropTypes.func,
    getAllFormStructure: PropTypes.func,
    deleteForm: PropTypes.func
};
const mapStateToProps = (state) => {
    return {
        forms: state.forms.forms,
        formStructure: state.general.formStructure
    };
};
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getPatientForms,
            editForm,
            getFormStructure,
            createFormInstance,
            getAllFormStructure,
            deleteForm
        },
        dispatch
    );
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(WithPatientFileHeader(PatientHistory, ['sidebar', 'visit']));
